import { OnConstrainedToLowerValueOptions } from './types';

import { DEFAULT_CORNER_RADIUS } from '~/core/constants';
import { CornerInfo } from '~/core/models';
import { enforceRadiusConstraints } from '~/core/utils';

export const getConstrainedSize = (
  corner: CornerInfo,
  onConstrainedToLowerValue?: (
    options: OnConstrainedToLowerValueOptions
  ) => void
): number => {
  const originalSize = corner.size ?? DEFAULT_CORNER_RADIUS;
  const constrainedSize = enforceRadiusConstraints(
    corner,
    corner.size ?? DEFAULT_CORNER_RADIUS
  );

  // Check if constrained to a lower value than intended and notify
  // Use intendedRadius if available (from user selection), otherwise use originalSize
  const intendedRadiusValue = corner.intendedRadius;
  const referenceSize = intendedRadiusValue ?? originalSize;
  const wasConstrained = constrainedSize < referenceSize;

  // Clear intendedRadius before callback to avoid issues, but after we've stored it
  if (corner.intendedRadius !== undefined) {
    delete corner.intendedRadius;
  }

  // Notify if constrained to a lower value than intended (even if constrainedSize === corner.size)
  // This handles the case where corner.size was already constrained in handleCornerSelection
  if (wasConstrained && onConstrainedToLowerValue) {
    // Use the stored intendedRadiusValue if it was set, otherwise use referenceSize
    // referenceSize is guaranteed to be a number since originalSize has a default
    const sizeToReport = intendedRadiusValue ?? referenceSize;

    onConstrainedToLowerValue({
      corner,
      originalSize: sizeToReport,
      constrainedSize,
    });
  }

  return constrainedSize;
};
